import { colors } from '@procore/core-react';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: '24px',
    letterSpacing: '0.15px',
    lineHeight: '32px',
    [theme.breakpoints.down(600)]: {
      fontSize: '20px',
      lineHeight: '28px',
    },
  },
  headerLink: {
    '&, &:hover, &:focus, &:active': {
      textDecoration: 'underline',
      color: colors.blue45,
      outline: 0,
      display: 'block',
    },
    '&:hover': { color: colors.black },
    '&:focus-visible': {
      boxShadow: `0px 0px 0px 2px ${colors.blue50}`,
    },
    '&> p': {
      fontSize: '14px !important',
      fontWeight: '400 !important' as any,
      whiteSpace: 'nowrap',
      textWrap: 'wrap',
    },
    marginBottom: '24px',
  },
  howAreMetricsCalculatedURL: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    marginBottom: '24px',
  },

  tile: {
    display: 'flex',
    alignItems: 'center',
  },

  value: {
    marginRight: '4px',
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '0.15px',
    lineHeight: '28px',
  },
  field: {
    fontWeight: '400 !important' as any,
    fontSize: '16px',
    letterSpacing: ' 0.25px',
    fontFeatureSettings: "'clig' off, 'liga' off",
    lineHeight: '16px',
  },
  firstGridTiles: {
    '& > :not(:first-child)': {
      paddingTop: '12px',
      paddingLeft: '24px',
      [theme.breakpoints.down(960)]: {
        paddingTop: '0px',
        paddingLeft: '24px',
      },
    },
    '& > :first-child': {
      paddingTop: '12px',
      paddingLeft: '0px',
      [theme.breakpoints.down(960)]: {
        paddingTop: '0px',
        paddingLeft: '0px',
      },
    },
  },
  secondeGridTiles: {
    '& > :not(:first-child)': {
      paddingTop: '12px',
      paddingLeft: '24px',
      [theme.breakpoints.down(960)]: {
        paddingTop: '0px',
        paddingLeft: '0px',
      },
    },
    '& > :first-child': {
      paddingTop: '12px',
      paddingLeft: '0px',
      [theme.breakpoints.down(960)]: {
        paddingTop: '0px',
        paddingLeft: '0px',
      },
    },
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: ' 20px',
    letterSpacing: ' 0.15px',
    marginBottom: '8px',
  },
  activeProcoreProjects: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    marginTop: '6px',
    marginBottom: '8px',
  },
}));
